import { yupResolver } from "@hookform/resolvers/yup";
import FormProvider, {
  RHFCheckbox,
  RHFSelect,
  RHFTextField,
} from "src/components/hook-form";
import * as Yup from "yup";

import { LoadingButton } from "@mui/lab";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Stack,
} from "@mui/material";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router";
import ReportController from "src/controller/Report.controller";
import { useProgram } from "src/hooks/useProgram";

// ----------------------------------------------------------------------

AddReportDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  data: PropTypes.array,
  enrollments: PropTypes.object,
};

export default function AddReportDialog({
  enrollments,
  open,
  onClose,
  data,
  student,
}) {
  const [loadingSend, setLoadingSend] = useState(false);
  const [loadingSave, setLoadingSave] = useState(false);

  const { id } = useParams();

  const CategorySchema = Yup.object().shape({
    report: Yup.string().required("Report is required."),
    program_name: Yup.string().required("Program is required."),
  });

  const defaultValues = {
    report: "",
    program_name: localStorage.getItem("selectedProgram") || "",
    include_in_automatic_report: false,
    student_id: id,
  };

  const methods = useForm({
    resolver: yupResolver(CategorySchema),
    defaultValues,
  });

  const {
    handleSubmit,
    setValue,
    reset,
    watch,
    clearErrors,
    formState: { isSubmitting },
    setError,
    control,
  } = methods;

  const { program, handleProgramChange } = useProgram(id, reset);

  useEffect(() => {
    setValue("program_name", program);
  }, [program, setValue]);
  const programOptions = enrollments
    .map((item) => item.program_name)
    .filter((name, index, self) => name && self.indexOf(name) === index);

  const onSubmit = async (data) => {
    const payload = { ...data, student_id: id };
    setLoadingSend(true);
    ReportController.create(payload)
      .then((result) => {
        reset();
        window.Toast("Report added successfully");
        clearErrors();
        onClose();
      })
      .catch((err) => {
        window.ToastError(err.message);
        setLoadingSend(false);
      });
  };

  const handleClosePopUp = () => {
    setLoadingSave(false);
    reset();
    onClose();
  };

  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={handleClosePopUp}>
      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <DialogTitle>Add Report</DialogTitle>

        <DialogContent dividers>
          <Stack spacing={2} paddingTop={1}>
            <RHFSelect
              size="small"
              name="program_name"
              label="Program"
              value={program}
              onChange={(event) => handleProgramChange(event.target.value)}
            >
              {programOptions?.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </RHFSelect>

            <RHFTextField
              multiline
              rows={5}
              size="small"
              name="report"
              label="Report"
            />
            <RHFCheckbox
              name="include_in_automatic_report"
              label="Include In Automatic Report"
            />
          </Stack>
        </DialogContent>

        <DialogActions>
          <LoadingButton
            type="submit"
            variant="contained"
            loading={isSubmitting}
          >
            Add
          </LoadingButton>

          <Button color="error" variant="contained" onClick={handleClosePopUp}>
            Cancel
          </Button>
        </DialogActions>
      </FormProvider>
    </Dialog>
  );
}
